/** * 模块名称: TranslationMachine.vue - 翻译笔 * 模块说明: * 创建时间:
2022-02-15 11:36 * 模块负责人: lkc * 修改记录: */
<template>
  <div>
    <!-- 头部 -->
    <div class="headBanner">
      <div class="headClass">
        <div class="tit">
          <h1>识字 查词 翻译 扫读 跟读 整读 复读</h1>
          <h1>一支笔解决全阶段学习困扰</h1>
        </div>
        <!-- <img src="@/assets/yj_4.png" alt="" /> -->
        <div class="div"></div>
      </div>
    </div>
    <div class="contBox">
      <!-- 产品简介 -->
      <h1>产品亮点</h1>
      <ul class="productList">
        <li v-for="item in list" :key="item.id">
          <div class="imgClass">
            <img :src="item.url" alt="" />
          </div>
          <span>{{ item.tit }}</span>
        </li>
      </ul>
      <!-- 系统学词 -->
      <h1>系统学词</h1>
      <h5>一支笔搞定听说读记全场景</h5>
      <ul class="fyTitList">
        <li>
          <div class="box1">
            <h1 class="blue">听</h1>
            <h4><span class="blue">单词</span>真人朗读 自然拼读</h4>
            <h4>见词能读 听音能写</h4>
            <h4>扫描<span class="blue">课本</span>内容 播放教材音频</h4>
          </div>
          <div class="box2">
            <img src="@/assets/fy6.jpg" alt="" />
          </div>
        </li>
        <li>
          <div class="box1">
            <h1 class="blue">说</h1>
            <h4>实时语音翻译</h4>
            <h4>中英互译 自动朗读</h4>
            <h4>跟读模拟对话练习</h4>
          </div>
          <div class="box2">
            <img src="@/assets/fy7.jpg" alt="" />
          </div>
        </li>
        <li>
          <div class="box1">
            <h1 class="blue">读</h1>
            <h4>单词/句子跟读评测</h4>
            <h4>跟着<span class="blue">考试</span>标准学英语</h4>
            <h4>每次听说练习 都是模拟实战</h4>
          </div>
          <div class="box2">
            <img src="@/assets/fy8.jpg" alt="" />
          </div>
        </li>
        <li>
          <div class="box1">
            <h1 class="blue">记</h1>
            <h4>生词一键收藏</h4>
            <h4>随时随地巩固学习</h4>
          </div>
          <div class="box2">
            <img src="@/assets/fy9.jpg" alt="" />
          </div>
        </li>
      </ul>
      <!-- 应用场景 -->
      <h1>应用场景</h1>
      <ul class="gpyScenario">
        <li>
          <img src="@/assets/fy10.jpg" alt="" />
          <h2>教育学习</h2>
          <span
            >满足小、初、高各阶段英语学习需要，哪里不会扫一扫，即刻解锁新知识</span
          >
        </li>
        <li>
          <img src="@/assets/fy11.jpeg" alt="" />
          <h2>出国旅游</h2>
          <span>化身随身翻译，精准解决旅游时的语言障碍</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { id: 1, url: require('@/assets/fy1.png'), tit: '极速扫译' },
        { id: 2, url: require('@/assets/fy2.png'), tit: '海量词库' },
        { id: 3, url: require('@/assets/fy3.png'), tit: '英汉查词' },
        { id: 4, url: require('@/assets/fy4.png'), tit: '生词收藏' },
        { id: 5, url: require('@/assets/fy5.png'), tit: '语音翻译' },
        { id: 6, url: require('@/assets/gpy1.png'), tit: '语音命令' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.headBanner {
  background: url('../../assets/fybBanner.png');
  background-size: 100% 100%;
  .headClass {
    width: 1200px;
    height: 360px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tit {
      width: 60%;
      color: #fff;
      text-align: left;
    }
    .div {
      width: 30%;
    }
  }
}
.contBox {
  padding: 30px;
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  .productList {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    justify-content: space-around;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 30%;
      justify-content: space-around;
      margin-bottom: 40px;
      .imgClass {
        width: 110px;
        height: 110px;
        border: 2px solid #1296db;
        text-align: center;
        line-height: 110px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100px;
        }
      }
    }
  }
  .fyTitList {
    display: flex;
    flex-direction: column;
    list-style: none;
    .blue {
      color: #1296db;
    }
    li {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-bottom: 20px;
      .box1 {
        width: 50%;
      }
      .box2 {
        width: 50%;
      }
    }
  }
  .gpyScenario {
    list-style: none;
    display: flex;
    justify-content: space-around;
    padding: 0;
    li {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 240px;
        height: 200px;
      }
      span {
        width: 240px;
        text-align: left;
      }
      h2 {
        width: 240px;
        text-align: left;
        margin: 10px 0;
      }
    }
  }
}
</style>
